  //  Quantity Box
jQuery('.product_submitBtn').addClass('disableBtn');
jQuery('.qtybox .btnqty').on('click', function(){
  var qty = parseInt(jQuery(this).parent('.qtybox').find('.quantity-input').val());
  if(jQuery(this).hasClass('qtyplus')) {
    let x = jQuery(this).closest('.qtydiv').find('.product_submitBtn').removeClass('disableBtn');

    if(qty >= 20){
      console.log(qty);
      qty = 19;	
    }
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  jQuery(this).parent('.qtybox').find('.quantity-input').val(qty);
});

// jQuery('.product_submitBtn').click(function(e){
// e.preventDefault();
// });


jQuery(document).ready(function(){
  jQuery('#ct_checkout').click(function(e){
    var isempty = jQuery('#date').val();
//     console.log(isempty);
    if(isempty != ""){
      jQuery('#dateError').addClass('d-none');
      window.location.href = "/checkout";
    }
    else{
      e.preventDefault();
      jQuery('#dateError').removeClass('d-none');
    }
  });
});



//Add Item in Cart
function addItem(form_class) {
  var id =  event.target.id;
//   console.log(id);
 
//   console.log($('#'+form_class).serialize());
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#'+form_class).serialize(),
    success:  function(data, textStatus, jqXHR) {
      	window.location.href= window.location.href; 
    },
    error:  function(jqXHR, textStatus, errorThrown) {
      console.log(jqXHR);
      console.log(jqXHR.responseJSON.description);
      $('.activePro #atcError').html('<p>'+jqXHR.responseJSON.description+'</p>');
      console.log(textStatus);
      console.log(errorThrown);
    }
  });
}


function getCount(){
    jQuery.getJSON('/cart.js', function(cart) {  
   	var cartItem = cart.item_count;
//       console.log(cart);
      $("#CartCount span").text(cartItem);
   });
}